export function extractErrorMessage(err, fallback = "Une erreur est survenue. Veuillez réessayer.") {
    const anyErr = err;
    const axiosMsg = anyErr?.response?.data?.error?.message;
    if (typeof axiosMsg === "string" && axiosMsg.trim())
        return axiosMsg;
    const dataMsg = anyErr?.data?.error?.message;
    if (typeof dataMsg === "string" && dataMsg.trim())
        return dataMsg;
    const directMsg = anyErr?.error?.message;
    if (typeof directMsg === "string" && directMsg.trim())
        return directMsg;
    if (anyErr instanceof Error && anyErr.message)
        return anyErr.message;
    return fallback;
}
